module.exports = __webpack_public_path__ + "static/media/backward_arrow.b325397d.svg";